module.exports = __webpack_public_path__ + "static/media/eyedropper.6b42c8ab.svg";